import { getTemplatePage } from "../../../data/models/page.model";
import { bus } from "@/main";


export default {
	name: "ContactsPage",
	data() {
		return {
			content: null,
			isReady: false,
		}
	},
	props: {},
	created() {
		bus.$emit("evalColors", true);
		bus.$emit("PAGE_IS_READY", true);
	},
	watch: {},
	computed: {},
	methods: {
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/error/error.page.js